module.exports = __webpack_public_path__ + "media/images/qrcode-6550e4efe0eaafea3105dc6816f99f44.svg";